__webpack_require__.p = "/kiosk/";